import { GradientStop } from '@type/sorr2025/DoughnutData';
import DoughnutData from '@type/sorr2025/DoughnutData';
import { ChartConfiguration } from 'chart.js';

type DoughnutChartConfig = {
    data: DoughnutData;
    backgroundColor: CanvasGradient;
};

const doughnutChartConfig = ({ data, backgroundColor }: DoughnutChartConfig): ChartConfiguration => {
    return {
        type: 'doughnut',
        data: {
            datasets: [
                {
                    //label: 'Acquisitions by year',
                    data: [data.value, 100 - data.value],
                    backgroundColor: [backgroundColor, 'rgba(0,0,0,0)'],
                    borderColor: '#B9E5E8',
                    borderWidth: 1,
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false,
                },
                datalabels: {
                    display: false,
                },
            },
            //@ts-expect-error This definitely exist, their types are bad
            cutout: '50%', // Adjust the size of the donut hole
        },
    };
};

export default doughnutChartConfig;
